import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ApplicationRoutes } from './common/routes';
import { AtlasComponent } from './atlas/atlas.component';
import { CustomerFacingComponent } from './customer-facing/customer-facing.component';

const routes: Routes = [
  {
    path: 'local-login',
    loadChildren: () => import('./local-login/local-login.module').then((m) => m.LocalLoginModule),
  },
  {
    path: ApplicationRoutes.customerLandingPage,
    component: CustomerFacingComponent,
  },
  {
    path: '',
    component: AtlasComponent,
    loadChildren: () => import('./navigable-app/navigable-app.module').then((m) => m.NavigableAppModule),
  },
];

declare let deployment: string;
if (typeof deployment !== 'undefined') {
  routes.shift();
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
